import { IKeHoachThucTapPhamVi } from "../../../model/response/xet-thuc-tap/IKeHoachThucTapPhamVi";
import { IKeHoachThucTapPhamViViewModel } from "../../../model/response/xet-thuc-tap/IKeHoachThucTapPhamViViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKeHoachThucTapPhamViActionsObj = {
    LOAD_BY_DOT_THUC_TAP_START: 0,
    LOAD_BY_DOT_THUC_TAP_SUCCESS: [] as IKeHoachThucTapPhamViViewModel[],
    LOAD_BY_DOT_THUC_TAP_ERROR: "",

    INSERT_START: {} as IKeHoachThucTapPhamVi,
    INSERT_SUCCESS: undefined,
    INSERT_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    SHOW_ADD_MODAL: 0,
    CLOSE_ADD_MODAL: undefined,
}

export const eKeHoachThucTapPhamViActionIds = generateActionTypeIds(eKeHoachThucTapPhamViActionsObj, "KE_HOACH_THUC_TAP_PHAM_VI");
export type IKeHoachThucTapPhamViActionTypes = IGenericActionType<typeof eKeHoachThucTapPhamViActionsObj, "KE_HOACH_THUC_TAP_PHAM_VI">;